import React from 'react'

import clsx from 'clsx'

import Button from 'components/Button'
import CtaButton from 'components/CtaButton'
import Icon from 'components/Icon'
import Paper from 'components/Paper'
import Typography from 'components/Typography'
import { useCompareBasket } from 'context/CompareBasketContext'
import { useEventContext } from 'context/EventContext'
import useViewport from 'hooks/useViewport'

import CompareList from './components/CompareList'
import SearchAppDialog from './components/SearchAppDialog'

import classes from './CompareBasket.module.scss'

/** @type {import("./types").default} */
const CompareBasket = ({ dialogOpen, setDialogOpen }) => {
  const { addEvent } = useEventContext({
    engagementComponent: 'compare-basket',
  })

  const { down } = useViewport()
  const compareBasket = useCompareBasket()
  const compareUrl = compareBasket.getUrl()

  const handleOpenBrowseItems = () => {
    setDialogOpen(true)
  }
  const handleRemoveItem = item => compareBasket.removeItem(item)
  const handleClearBasket = () => compareBasket.clear()
  const handleDialogClose = () => {
    setDialogOpen(false)
  }
  const showHelpingText =
    (down('sm') && compareBasket.items.length < 2) || (!down('sm') && compareBasket.items.length === 0)

  return (
    <>
      <Paper className={clsx('CompareBasket', classes.root)} data-testid="compare-basket">
        <hr className={classes.swipeBar} />
        <Typography variant="heading-sm" className={classes.title}>
          App comparison
        </Typography>
        {showHelpingText && (
          <Typography variant="body-xs" className={classes.helpText}>
            Add up to 4 apps below to see how they compare. You can also use the &quot;Compare&quot; buttons while
            browsing.
          </Typography>
        )}
        <CompareList onAddClick={handleOpenBrowseItems} onRemoveClick={handleRemoveItem} apps={compareBasket.items} />
        <div className={classes.bottomActions}>
          {!down('sm') && compareUrl && (
            <CtaButton
              variant="text"
              size="small"
              label="Remove all"
              fullWidth
              onClick={handleClearBasket}
              className={classes.clearBasketButton}
              {...addEvent({
                engagementDestination: 'compare-basket_remove-all',
                engagementDetails: 'text-link_remove-all',
                name: 'engagement_compare_tray',
              })}
            />
          )}
          <CtaButton
            size="small"
            fullWidth
            href={compareUrl}
            onClick={handleClearBasket}
            disabled={!compareUrl}
            className={classes.seeCompareBtn}
            {...addEvent({
              engagementDestination: 'go-to_product_comparisons',
              engagementDetails: 'button_full-comparison',
              name: 'engagement_cta_compare',
            })}
          >
            <Icon icon={['ga', 'compare']} />
            see comparison
          </CtaButton>
          {down('sm') && (
            <Button
              disabled={!compareUrl}
              className={clsx(classes.clearBasketIconButton, { [classes.disabled]: !compareUrl })}
              onClick={handleClearBasket}
              {...addEvent({
                engagementDestination: 'compare-basket_remove-all',
                engagementDetails: 'text-link_remove-all',
                name: 'engagement_compare_tray',
              })}
            >
              <Icon icon={['fas', 'trash-can']} />
            </Button>
          )}
        </div>
      </Paper>
      <SearchAppDialog isOpen={dialogOpen} onClose={handleDialogClose} />
    </>
  )
}

export default CompareBasket
